import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';
import { Experiment, ExperimentFormData } from './types';

export const hydrateFormData = (data: any): ExperimentFormData => {
	const { buckets } = data;

	let controlBucket = _find(buckets, (bucket) => bucket.name === 'control');
	let testBuckets = _filter(buckets, (bucket) => bucket.name !== 'control');

	controlBucket = { ...controlBucket, share: parseInt(controlBucket.share, 10) };
	testBuckets = _map(testBuckets, (bucket) => ({ ...bucket, share: parseInt(bucket.share, 10) }));

	const hydratedData = {
		controlBucket,
		testBuckets,
		..._pick(data, [
			'_id',
			'created',
			'name',
			'start',
			'end',
			'isLive',
			'createdBy',
			'description',
			'flowOrScreensImpacted',
			'fixedBuckets',
			'created',
			'isExpired',
			'modified',
			'isRunning',
			'isAllowed',
			'useOldAbFlow'
		])
	};

	return hydratedData;
};

export const dehydrateFormData = (formData: ExperimentFormData): { experimentData: Experiment } => {
	const { controlBucket, testBuckets } = formData;
	const buckets = [...testBuckets, controlBucket];
	const experimentData = {
		buckets,
		..._omit(formData, ['testBuckets', 'controlBucket'])
	};

	return { experimentData };
};
